var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTask1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427319789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 40",
    d: "M23 22.5H3.25C2.00736 22.5 1 21.4926 1 20.25V6.25C1 5.00736 2.00736 4 3.25 4H25.75C26.9926 4 28 5.00736 28 6.25V20.25C28 21.4926 26.9926 22.5 25.75 22.5H24.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 41",
    d: "M13 9.5L11.4342 8.71708C11.2347 8.61735 11 8.7624 11 8.98541V17.4901C11 17.7189 11.2457 17.8635 11.4457 17.7524L19.5028 13.2762C19.7137 13.1591 19.7071 12.8535 19.4913 12.7456L15 10.5M6 24C6.8 24 17.6667 24 23 24",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask1);
export default __webpack_public_path__ + "static/media/task-1.97a89c9be1973e8e0d0d198bc045deb7.svg";
export { ForwardRef as ReactComponent };